/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_Stat_All_TimeInputs */

const en_seller_dashboard_stat_all_time = /** @type {(inputs: Seller_Dashboard_Stat_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all time`)
};

const es_seller_dashboard_stat_all_time = /** @type {(inputs: Seller_Dashboard_Stat_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`todo el tiempo`)
};

const fr_seller_dashboard_stat_all_time = /** @type {(inputs: Seller_Dashboard_Stat_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`depuis toujours`)
};

const de_seller_dashboard_stat_all_time = /** @type {(inputs: Seller_Dashboard_Stat_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamte Zeit`)
};

const ja_seller_dashboard_stat_all_time = /** @type {(inputs: Seller_Dashboard_Stat_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全期間`)
};

const zh_seller_dashboard_stat_all_time = /** @type {(inputs: Seller_Dashboard_Stat_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`历史总计`)
};

const ar_seller_dashboard_stat_all_time = /** @type {(inputs: Seller_Dashboard_Stat_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`في كل الأوقات`)
};

const id_seller_dashboard_stat_all_time = /** @type {(inputs: Seller_Dashboard_Stat_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sepanjang waktu`)
};

const it_seller_dashboard_stat_all_time = /** @type {(inputs: Seller_Dashboard_Stat_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`di sempre`)
};

const ru_seller_dashboard_stat_all_time = /** @type {(inputs: Seller_Dashboard_Stat_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`за все время`)
};

const pt_seller_dashboard_stat_all_time = /** @type {(inputs: Seller_Dashboard_Stat_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`todo o período`)
};

const ko_seller_dashboard_stat_all_time = /** @type {(inputs: Seller_Dashboard_Stat_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 기간`)
};

/**
* | output |
* | --- |
* | "all time" |
*
* @param {Seller_Dashboard_Stat_All_TimeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_stat_all_time = /** @type {((inputs?: Seller_Dashboard_Stat_All_TimeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Stat_All_TimeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_stat_all_time(inputs)
	if (locale === "es") return es_seller_dashboard_stat_all_time(inputs)
	if (locale === "fr") return fr_seller_dashboard_stat_all_time(inputs)
	if (locale === "de") return de_seller_dashboard_stat_all_time(inputs)
	if (locale === "ja") return ja_seller_dashboard_stat_all_time(inputs)
	if (locale === "zh") return zh_seller_dashboard_stat_all_time(inputs)
	if (locale === "ar") return ar_seller_dashboard_stat_all_time(inputs)
	if (locale === "id") return id_seller_dashboard_stat_all_time(inputs)
	if (locale === "it") return it_seller_dashboard_stat_all_time(inputs)
	if (locale === "ru") return ru_seller_dashboard_stat_all_time(inputs)
	if (locale === "pt") return pt_seller_dashboard_stat_all_time(inputs)
	return ko_seller_dashboard_stat_all_time(inputs)
});